import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

export const authGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loginTree = (): UrlTree => router.parseUrl('/auth/login');

  if (!authService.isLoggedIn()) {
    return of(loginTree());
  }

  return authService.validateAuthentication().pipe(
    map(isValid => {
      if (isValid) {
        return true;
      }
      if (authService.isLoggedIn()) {
        console.warn('Auth validation returned false but user is logged in, allowing access');
        return true;
      }
      return loginTree();
    }),
    catchError(error => {
      console.error('Auth guard validation failed:', error);
      if (authService.isLoggedIn()) {
        console.warn('Auth validation error but user is logged in, allowing access');
        return of(true);
      }
      return of(loginTree());
    })
  );
};
